import { render, staticRenderFns } from "./ModalRegistration.vue?vue&type=template&id=59e2b160&scoped=true"
import script from "./ModalRegistration.vue?vue&type=script&lang=js"
export * from "./ModalRegistration.vue?vue&type=script&lang=js"
import style0 from "./ModalRegistration.vue?vue&type=style&index=0&id=59e2b160&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e2b160",
  null
  
)

export default component.exports